import { render, staticRenderFns } from "./UploadCellAddDZ.vue?vue&type=template&id=4e6fa9c4&scoped=true"
import script from "./UploadCellAddDZ.vue?vue&type=script&lang=js"
export * from "./UploadCellAddDZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6fa9c4",
  null
  
)

export default component.exports